import { render, staticRenderFns } from "./ShippingOption.vue?vue&type=template&id=5d38da12&scoped=true"
import script from "./ShippingOption.vue?vue&type=script&lang=js"
export * from "./ShippingOption.vue?vue&type=script&lang=js"
import style0 from "./ShippingOption.vue?vue&type=style&index=0&id=5d38da12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d38da12",
  null
  
)

export default component.exports